export default __webpack_public_path__ + "static/media/grip-lines-vertical.a817b405.svg";